import appLayout from '../layouts/AppLayout.vue'
export default [
  // USER
  {
    path: '/markup/',
    name: 'markup-list',
    component: () => import('../views/markup/MarkupsIndex.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/markup/create',
    name: 'markup-create',
    component: () => import('../views/markup/New.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/markup/:id?',
    name: 'markup-edit',
    component: () => import('../views/markup/Edit.vue'),
    meta: { layout: appLayout }
  }
]
